import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Calendar, BarChart3, Bell, User, Shield, Lock } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useSubscription } from '../../context/SubscriptionContext';

const navItems = [
  { to: '/', icon: Home, label: 'Inicio' },
  { to: '/calendar', icon: Calendar, label: 'Calendario' },
  { to: '/stats', icon: BarChart3, label: 'Estadísticas' },
  { to: '/reminders', icon: Bell, label: 'Recordatorios' },
  { to: '/profile', icon: User, label: 'Perfil' },
];

export const BottomNav: React.FC = () => {
  const { user } = useAuth();
  const { canUse } = useSubscription();
  const isAdmin = user?.is_admin || user?.admin_role;

  const allNavItems = isAdmin
    ? [...navItems, { to: '/admin', icon: Shield, label: 'Admin' }]
    : navItems;

  return (
    <nav className="bottom-nav lg:hidden">
      <div className="flex justify-around items-center max-w-lg mx-auto">
        {allNavItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `nav-item relative ${isActive ? 'active' : ''}`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <motion.div
                    layoutId="nav-indicator"
                    className="absolute inset-0 rounded-2xl"
                    style={{ background: 'var(--color-accent-soft)' }}
                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                  />
                )}
                <span className="relative z-10">
                  {item.label === 'Recordatorios' && !canUse('reminders') ? (
                    <div className="relative">
                      <item.icon size={22} strokeWidth={isActive ? 2.5 : 2} />
                      <Lock size={6} className="absolute -bottom-1 -right-1.5 opacity-50" />
                    </div>
                  ) : (
                    <item.icon size={22} strokeWidth={isActive ? 2.5 : 2} />
                  )}
                </span>
                <span className="relative z-10 text-[10px]">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
